module.exports = __webpack_public_path__ + "static/cutiss-48970ed76508acb932eec83583b0b848.png";